import { Metric } from '@agilelab/plugin-wb-governance-common';
import { Box } from '@material-ui/core';
import { FC, useMemo, useState } from 'react';
import { extractGovernanceErrorInfo } from '../../../../utils/governance.utils';
import { Editor } from '../../../common/Editor/Editor';
import { ErrorBox } from '../../../common/ErrorBox/ErrorBox';

interface Props {
  metric: Metric;
  test: {
    errors?: string[];
    content: string;
    name: string;
  };
}

export const GovernanceTestOverviewMetricDetails: FC<Props> = props => {
  const { test, metric } = props;
  const [currentErrorIndex, setCurrentErrorIndex] = useState<number>(0);

  const handleGoToLine = (line: number, id: string) => {
    const editorElement = document.getElementById(id);
    const monacoEditor = (editorElement as any).monacoEditor;

    if (monacoEditor) {
      monacoEditor.revealLineInCenter(line);
      monacoEditor.setPosition({ lineNumber: line, column: 1 });
      monacoEditor.focus();
    }
  };

  const errors = useMemo(
    () =>
      (test?.errors || []).map(error =>
        extractGovernanceErrorInfo({ policyId: metric.metricId, error }),
      ),
    [metric.metricId, test?.errors],
  );

  const currentError = useMemo(
    () => errors?.at(currentErrorIndex),
    [currentErrorIndex, errors],
  );

  const handleSwitch = (index: number) => {
    setCurrentErrorIndex(index);
  };

  return (
    <Box>
      {!!currentError && (
        <ErrorBox
          policyEditorId={`policy-${props.metric.groupId}`}
          descriptorEditorId={`descriptor-${props.metric.groupId}`}
          headerTitle="Error Info"
          error={currentError}
          handleGoToLine={handleGoToLine}
          navigation={{
            current: currentErrorIndex,
            total: errors?.length || 0,
            handleSwitch: handleSwitch,
          }}
        />
      )}

      {test.content && (
        <Box mt={2}>
          <Editor
            id={`descriptor-${metric.groupId}`}
            name={`Descriptor: ${test.name}`}
            editable={false}
            content={test.content}
            highlightLines={currentError?.descriptorErrorRows}
          />
        </Box>
      )}
    </Box>
  );
};
